import { useEffect, useState } from 'react'
import { Loader2 } from 'lucide-react'
import { cn } from '@/lib/utils'

interface LoadingSpinnerProps {
  className?: string
  size?: 'sm' | 'md' | 'lg'
  /**
   * When true, shows a "taking longer than expected" message after 8s so the
   * user never sits staring at a spinner with zero feedback when the network
   * or backend is misbehaving.
   */
  withTimeoutMessage?: boolean
}

export const LoadingSpinner = ({
  className,
  size = 'md',
  withTimeoutMessage = true,
}: LoadingSpinnerProps) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
  }

  const [slow, setSlow] = useState(false)

  useEffect(() => {
    if (!withTimeoutMessage) return
    const t = setTimeout(() => setSlow(true), 8000)
    return () => clearTimeout(t)
  }, [withTimeoutMessage])

  return (
    <div className="flex flex-col items-center justify-center gap-3 p-8">
      <Loader2 className={cn('animate-spin text-primary', sizeClasses[size], className)} />
      {slow && (
        <div className="text-center space-y-2 max-w-sm">
          <p className="text-sm text-muted-foreground">
            This is taking longer than expected…
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="text-sm text-primary underline hover:no-underline"
          >
            Reload the page
          </button>
        </div>
      )}
    </div>
  )
}
